import { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { AnamAvatarQuiz } from './AnamAvatarQuiz';
import { useQuizStore } from '../../hooks';

export const AnamAvatarQuizModal = ({ show, onHide }) => {
  const { isAllquestionsAnswered } = useQuizStore();

  // Close modal when quiz is completed
  useEffect(() => {
    if (isAllquestionsAnswered && show) {
      // Small delay to show completion message
      const timer = setTimeout(() => {
        onHide();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isAllquestionsAnswered, show, onHide]);

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size="lg"
      className="anam-avatar-quiz-modal"
      backdrop="static"
      keyboard={false}
      fullscreen="lg-down"
    >
      <Modal.Header closeButton>
        <Modal.Title>Encuesta con Avatar ANAM AI</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ minHeight: '500px', padding: '2rem' }}>
        {show && <AnamAvatarQuiz />}
      </Modal.Body>
    </Modal>
  );
};
